/*
  vy-guarantee-atc.js  —  Veyla, growth-serum PDP.

  Any link whose href ends in #veyla-atc stops being a scroll-to-top anchor and
  instead fires the real main add-to-cart button, so it adds whatever the Kaching
  buybox currently has selected (bundle, quantity, selling plan, deal properties)
  and opens the cart drawer exactly like the buybox CTA does.

  It does NOT rebuild the cart call. Kaching writes its whole state into the main
  product form as hidden inputs, and the theme's <product-form> owns the fetch and
  the drawer. Clicking the button that both of them already listen to is the only
  way this stays correct when the client changes a deal.

  If the button can't be found, the link falls back to scrolling to the buybox,
  which is the behaviour it had before.
*/
(function () {
  var SENTINEL = '#veyla-atc';
  var lock = 0;

  function mainAtc() {
    return (
      document.querySelector('product-form[data-main="true"] form[action*="/cart/add"] button[type="submit"][name="add"]') ||
      document.querySelector('form[action*="/cart/add"][id*="__main"] button[type="submit"][name="add"]') ||
      document.querySelector('.main-product-form button[type="submit"][name="add"]') ||
      document.querySelector('button.main-product-atc')
    );
  }

  function buybox() {
    return (
      document.querySelector('kaching-bundle') ||
      document.querySelector('product-form[data-main="true"]') ||
      document.querySelector('form[action*="/cart/add"][id*="__main"]')
    );
  }

  function scrollToBuybox() {
    var el = buybox();
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
  }

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="' + SENTINEL + '"]') : null;
      if (!a) return;

      e.preventDefault();

      var now = Date.now();
      if (now - lock < 800) return; // double-tap guard
      lock = now;

      var btn = mainAtc();
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') {
        scrollToBuybox();
        return;
      }
      btn.click();
    },
    true
  );
})();
